<template>
  <div>
    <Form ref="topicForm" :rules="ruleValidate" :model="topicInfo" :label-width="120">
      <FormItem label="报错描述" prop="error_msg">
        <UEditor v-model="topicInfo.error_msg" :maxlength="300" :height="150"></UEditor>
      </FormItem>
      <FormItem label="错题基本信息">
        <div class="base-info">
          <div>
            <span>试题类型：</span>
            <span class="info">{{topicInfo.ques_type_name}}</span>
          </div>
          <div class="stem">
            <span>题干摘要：</span>
            <span class="info" v-html="topicInfo.ques_stem"></span>
          </div>
          <router-link
            :to="{name:'QuestionBankTopicEdit',query:{id:topicInfo.ques_id,from:'error'}}"
          >查看详情并处理</router-link>
        </div>
      </FormItem>
      <FormItem label="处理状态" prop="status">
        <EnumSelect type="TopicErrorState" v-model="topicInfo.status"></EnumSelect>
      </FormItem>
      <FormItem label="备注信息" prop="remake">
        <UEditor v-model="topicInfo.remark" :maxlength="300" :height="150"></UEditor>
      </FormItem>
      <FormItem class="center">
        <Button size="large" :to="{name: 'QuestionTopicError'}">返回</Button>
        <Button
          size="large"
          style="margin: 0 15px;"
          type="primary"
          @click="submitForm('topicForm')"
        >保存并返回</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import UEditor from "@/components/UEditor.vue";
import { QuestionType } from "../../utils/enums.js";

export default {
  name: "QuestionTopicErrorEdit",
  components: {
    UEditor
  },
  data() {
    return {
      topicInfo: {
        error_msg: "",
        ques_type_name: "",
        ques_stem: "",
        ques_id: "",
        status: "",
        remark: ""
      },
      ruleValidate: {
        error_msg: [
          {
            required: true
          }
        ]
      }
    };
  },
  async created() {
    let data = await this.$http.get(
      "/api/error/question/" + this.$route.query.id
    );
    this.topicInfo.error_msg = data.error_msg;
    this.topicInfo.ques_type_name = QuestionType.getValue(data.ques_type);
    this.topicInfo.ques_stem = data.ques_stem;
    this.topicInfo.status = data.status.toString();
    this.topicInfo.remark = data.remark;
    this.topicInfo.ques_id = data.ques_id;
  },
  methods: {
    submitForm(ref) {
      this.$refs[ref].validate(async valid => {
        if (!valid) {
          return;
        }
        await this.$http.put("/api/error/question/" + this.$route.query.id, {
          status: this.topicInfo.status,
          remark: this.topicInfo.remark,
          error_msg: this.topicInfo.error_msg
        });
        this.$Message.saveSuccess();
        this.$router.push({
          name: "QuestionTopicError"
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.base-info {
  .stem {
    line-height: 1.5;
    display: flex;
    > span:first-child {
      white-space: nowrap;
    }
  }
  .info {
    color: #ccc;
    margin-right: 20px;
  }
}
</style>